export const DayByMs = 24 * 3600 * 1000; // 24 hours
